import { render, staticRenderFns } from "./AddendaVW_PSV.vue?vue&type=template&id=5ef02e57&"
import script from "./AddendaVW_PSV.vue?vue&type=script&lang=js&"
export * from "./AddendaVW_PSV.vue?vue&type=script&lang=js&"
import style0 from "./AddendaVW_PSV.vue?vue&type=style&index=0&id=5ef02e57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports